/**
 * WebSocket Context Provider
 *
 * Placeholder context kept for structural compatibility.
 * Real-time price connections are managed per-hook via useMarketWS,
 * which routes through the backend /api/v1/market/ws/prices endpoint.
 */

import React, { createContext, useContext } from 'react';

interface WebSocketContextType {
  isConnected: boolean;
}

const WebSocketContext = createContext<WebSocketContextType>({
  isConnected: false,
});

export const useWebSocket = () => useContext(WebSocketContext);

interface WebSocketProviderProps {
  children: React.ReactNode;
}

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {
  return (
    <WebSocketContext.Provider value={{ isConnected: true }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
